<template>
  <div class="toolbar__items">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'toolbar-items'
}
</script>
